export const normalizeTakozCount = (value: number, previous?: number): number => {
  if (!Number.isFinite(value) || value <= 0) {
    return 0;
  }

  const intValue = Math.max(0, Math.round(value));

  if (intValue === 1) {
    if (previous !== undefined && previous >= 2) {
      return 0;
    }
    return 2;
  }

  return intValue;
};
